export function getPriorInterimNumbers(submissions, currentInterimNumber, coveredInterimNumbers = []) {
    const current = Number(currentInterimNumber || 0);
    const covered = new Set(coveredInterimNumbers.map(Number));
    const numbers = (Array.isArray(submissions) ? submissions : [])
        .map((submission) => Number(submission?.interim_number || 0))
        .filter((number) => Number.isInteger(number) && number > 0 && (!current || number < current) && !covered.has(number));
    return Array.from(new Set(numbers)).sort((first, second) => first - second);
}